"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ElementResponses;

(function (ElementResponses) {
  var ElementResponse =
  /** @class */
  function () {
    /**
    * Response containing content type element
    *
    * @constructor
    * @param {Element} element - Content type element
    * @param {ICloudResponseDebug} debug - Debug information from the response
    */
    function ElementResponse(element, debug) {
      this.element = element;
      this.debug = debug;
    }

    return ElementResponse;
  }();

  ElementResponses.ElementResponse = ElementResponse;
})(ElementResponses = exports.ElementResponses || (exports.ElementResponses = {}));